import React, { useEffect, useRef, useState } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { getSectionByID } from "../../Tools/Tools";
import { useAtomValue, useSetAtom } from "jotai";
import { sectionListAtom, selectedSectionAtom, setSelectedSectionAtom } from "../../../../atoms";

// import { Button, IconButton } from "@mui/material";

export default function Breadcumbs(props) {
  const sideBarSelected = useAtomValue(selectedSectionAtom);
  const sideBarData = useAtomValue(sectionListAtom);
  const [Links, setLinks] = useState([]);
  const setSelectedSection = useSetAtom(setSelectedSectionAtom);
  const breadcrumbsRef = useRef(null);

  useEffect(() => {
    if (sideBarSelected.ID !== "" && sideBarData) {
      setLinks(CreateBreadcrumbs());
    }
  }, [sideBarSelected.ID]);

  function ClearBreadCrumbs() {
    if (breadcrumbsRef.current) {
      for (const value of Object.values(breadcrumbsRef.current.firstChild.children)) {
        if (value.id === "noneBreadcrumbs") value.remove();
      }
    }
  }

  function CreateBreadcrumbs() {
    let arr = [],
      Name;
    ClearBreadCrumbs();
    for (const [key, value] of Object.entries(sideBarData)) {
      Name = value.Title === undefined ? value.Name : value.Title;
      if (!value.Deep) {
        arr = [];
        arr.push(
          <Link underline="hover" key={key} color="inherit" href="#" idsec={value.ID} onClick={onClickLink}>
            {Name}
          </Link>,
        );
      } else {
        if (arr.length > Number(value.Deep)) arr.pop();
        arr.push(
          <Link underline="hover" key={key} color="inherit" href="#" idsec={value.ID} onClick={onClickLink}>
            {Name}
          </Link>,
        );
      }
      if (value.ID === sideBarSelected.ID) {
        return arr;
      }
    }

    return (
      <Link underline="hover" color="inherit" href="#" idsec={sideBarSelected.ID} onClick={onClickLink}>
        {sideBarSelected.Name}
      </Link>
    );
  }

  function onClickLink(event) {
    const ID = event.target.getAttribute("idsec");
    ClearBreadCrumbs();
    event.preventDefault();
    if (ID !== sideBarSelected.ID) {
      setSelectedSection(getSectionByID(ID));
    }
  }

  return (
    <>
      <div style={{ display: "none" }}>
        <Stack spacing={1}>
          <Breadcrumbs
            separator={
              //   <Button
              //     variant="text"
              //     sx={{ minWidth: "1px", width: "1px", color: "inherit" }}
              //   >
              <NavigateNextIcon fontSize="small" />
              //   </Button>
            }
            id={"BreadcrumbsNavigateNextIcon"}
          >
            <Link>{"Name"}</Link>
            <Link>{"Name1"}</Link>
          </Breadcrumbs>
        </Stack>
      </div>
      <Stack spacing={1}>
        <Breadcrumbs
          ref={breadcrumbsRef}
          separator={
            //   <Button
            //     variant="text"
            //     sx={{ minWidth: "1px", width: "1px", color: "inherit" }}
            //   >
            <NavigateNextIcon fontSize="small" />
            //   </Button>
          }
          sx={{ color: "inherit" }}
          id={"BreadcrumbsSelected"}
        >
          {Links}
        </Breadcrumbs>
      </Stack>
    </>
  );
}
